import React, { useState } from "react";
import { LTabStrip } from "@loffa/gpp-modules";
import UserEntitlementReport from "./UserEntitlementReport/UserEntitlementReport";

export default function ReportsManagment() {
  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <LTabStrip
      selected={selectedTab}
      onSelect={(e : any) => setSelectedTab(e.selected)}
      tabs={[
        {
          title: "User Entitlement Report",
          body: <UserEntitlementReport />,
        },
      ]}
    />
  );
}
